import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from '../../../views/App/App';
import {
  ProgrammeBookingInboxItem,
  ProgrammeBookingInvitesResponse,
  ProgrammeBookingDraftPayload,
  StudentProgrammeBookingConfirmPayload
} from '../../../views/GenericView/components/ClubProgrammes/ProgrammeBooking/ProgrammeBooking.types';

export function getStudentProgrammeBookingInbox(
  user: AppUser,
  schoolId: string,
  playerPermissionId?: string
): Promise<ProgrammeBookingInboxItem[]> {
  const { roleSessionKey: key } = user;

  return axios
    .get(`${window.apiBase}/i/clubs/programmes/inbox`, {
      headers: { usid: key },
      params: {
        schoolId,
        ...(playerPermissionId ? { playerPermissionId } : {})
      }
    })
    .then(r => r.data);
}

export function getStudentProgrammeBookingInvites(
  user: AppUser,
  programmeId: string,
  playerPermissionId: string
): Promise<ProgrammeBookingInvitesResponse> {
  const { roleSessionKey: key } = user;

  return axios
    .get(`${window.apiBase}/i/clubs/programmes/${programmeId}/invites`, {
      headers: { usid: key },
      params: { playerPermissionId }
    })
    .then(r => r.data);
}

export function draftStudentProgrammeClubInvite(
  user: AppUser,
  messageId: string,
  data: ProgrammeBookingDraftPayload
): Promise<any> {
  const { roleSessionKey: key } = user;

  return axios
    .post(`${window.apiBase}/i/clubs/programme-messages/${messageId}/draft`, data, {
      headers: { usid: key }
    })
    .then(r => r.data);
}

export function undraftStudentProgrammeClubInvite(user: AppUser, messageId: string): Promise<any> {
  const { roleSessionKey: key } = user;

  return axios
    .request({
      method: 'DELETE',
      url: `${window.apiBase}/i/clubs/programme-messages/${messageId}/draft`,
      headers: { usid: key }
    })
    .then(r => r.data);
}

export function updateAcceptedStudentProgrammeClubInvite(
  user: AppUser,
  messageId: string,
  data: ProgrammeBookingDraftPayload
): Promise<any> {
  const { roleSessionKey: key } = user;

  return axios
    .put(`${window.apiBase}/i/clubs/programme-messages/${messageId}/accepted`, data, {
      headers: {
        usid: key,
        'Content-Type': 'application/json'
      }
    })
    .then(r => r.data);
}

export function cancelStudentProgrammeClubInvite(user: AppUser, messageId: string): Promise<any> {
  const { roleSessionKey: key } = user;

  return axios
    .request({
      method: 'DELETE',
      url: `${window.apiBase}/i/clubs/programme-messages/${messageId}/accepted`,
      headers: { usid: key }
    })
    .then(r => r.data);
}

export function confirmStudentProgrammeBooking(
  user: AppUser,
  programmeId: string,
  data: StudentProgrammeBookingConfirmPayload
): Promise<{ accepted: any[]; removedDrafts: number }> {
  const { roleSessionKey: key } = user;

  return axios
    .post(`${window.apiBase}/i/clubs/programmes/${programmeId}/confirm`, data, {
      headers: { usid: key }
    })
    .then(r => r.data);
}
